import React, { Component } from 'react';
import { Button, Snackbar } from '@cimpress/react-components';

export default class SnackbarDemo extends Component {
  state = {
    showSnackbar: false,
    status: 'success',
  };

  hideSnackbar = () => this.setState({ showSnackbar: false });

  render() {
    const { showSnackbar, status } = this.state;
    const cols = [undefined, 'info', 'success', 'warning', 'danger'];

    return (
      <div>
        {cols.map(name => (
          <Button
            className={`btn btn-block btn-outline-${name}`}
            style={{ marginRight: 10 }}
            onClick={() => this.setState({ showSnackbar: true, status: name })}
          >
            Show {name} snackbar
          </Button>
        ))}

        <Snackbar show={showSnackbar} status={status} delay={4000} onHideSnackbar={this.hideSnackbar}>
          I am a snackbar!
        </Snackbar>
      </div>
    );
  }
}
